import { useRouter } from '@application/utils';
import { Label } from '@presentation/components';
import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import * as RootStyled from '../../styled';
import { StepCard } from '../StepCard';
import bubbleFR from '../assets/bubbleFR.webp';
import bubbleNL from '../assets/bubbleNL.webp';
import step1 from '../assets/step1.svg';
import step2 from '../assets/step2.svg';
import step3 from '../assets/step3.svg';
import * as Styled from './styled';

const bubble = {
  fr: bubbleFR,
  nl: bubbleNL,
};

export const StepsSection: FC = () => {
  const { translate } = useTranslation({ keyPrefix: 'breederLanding.steps' });
  const { language } = useRouter();

  const showBubble = ['fr', 'nl'].includes(language);

  return (
    <>
      <RootStyled.Title centered="true">{translate('title')}</RootStyled.Title>

      <Styled.TopMargin>
        <Styled.Label>
          <Label content={translate('label')} />
        </Styled.Label>

        <Styled.Cards>
          <StepCard
            label={translate('step1.label')}
            img={step1}
            title={translate('step1.title')}
            text={translate('step1.text')}
          />
          <StepCard
            label={translate('step2.label')}
            img={step2}
            title={translate('step2.title')}
            text={translate('step2.text')}
          />
          <StepCard
            label={translate('step3.label')}
            img={step3}
            title={translate('step3.title')}
            text={translate('step3.text')}
            bubble={showBubble ? bubble[language as 'fr' | 'nl'] : undefined}
          />
        </Styled.Cards>
      </Styled.TopMargin>
    </>
  );
};
